// extracted by mini-css-extract-plugin
module.exports = {"header":"user-details-header_header__2armS","wrapper":"user-details-header_wrapper__2L1o3"};